import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router";
const LandingPage = lazy(() =>
  import("../components/landing-page/NewLandingPage").then((mod) => ({
    default: mod.default,
  })),
);

const MY_INFO_PAGE = lazy(() =>
  import("../components/employee-my-info/MyInfoV2").then((mod) => ({
    default: mod.default,
  })),
);

const LmsManagement = lazy(() =>
  import("../components/lms-service/LmsLayout").then((mod) => ({
    default: mod.default,
  })),
);

// import LandingPage from "../components/landing-page/LandingPage"
const PlatformLayout = lazy(() =>
  import("../components/platform/PlatformLayout").then((mod) => ({
    default: mod.default,
  })),
);
const SetupLayout = lazy(() =>
  import("../components/setup/NewSetuplayout").then((mod) => ({
    default: mod.default,
  })),
);

// ==========================================================================================================
const index = () => {
  return (
    // <BrowserRouter>
    <Routes>
      <Route
        index
        path="/"
        element={
          <Suspense
            fallback={<div style={{ textAlign: "center" }}>Loading...</div>}
          >
            <>Dashboard</>
          </Suspense>
        }
      />
      <Route
        index
        path="/my_info"
        element={
          <Suspense
            fallback={<div style={{ textAlign: "center" }}>Loading...</div>}
          >
            <MY_INFO_PAGE />
          </Suspense>
        }
      />
        <Route
        index
        path="/lms"
        element={
          <Suspense
            fallback={<div style={{ textAlign: "center" }}>Loading...</div>}
          >
            <LmsManagement />
          </Suspense>
        }
      />
      <Route
        index
        path="/workforce"
        element={
          <Suspense
            fallback={<div style={{ textAlign: "center" }}>Loading...</div>}
          >
            <LandingPage />
          </Suspense>
        }
      />
      <Route
        index
        path="/platform"
        element={
          <Suspense
            fallback={<div style={{ textAlign: "center" }}>Loading...</div>}
          >
            <PlatformLayout />
          </Suspense>
        }
      />
      <Route
        index
        path="/setup"
        element={
          <Suspense
            fallback={<div style={{ textAlign: "center" }}>Loading...</div>}
          >
            <SetupLayout />
          </Suspense>
        }
      />
    </Routes>
    // </BrowserRouter>
  );
};

export default index;

// import { Routes, Route } from "react-router-dom";

// const AppRoutes = () => {
//   return (
//     <Routes>
//       <Route
//         path="/"
//         element={
//           <div style={{ padding: "50px", fontSize: "30px" }}>
//             Route is working
//           </div>
//         }
//       />
//     </Routes>
//   );
// };

// export default AppRoutes;
